// @flow

export default function isMobile() {
  return global.innerWidth < 1024;
}
